"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var Styles_1 = require("./Styles");
var ContentFooter = function (props) {
    var leftButton = props.leftButton, rightButton = props.rightButton;
    var responsiveSize = react_1.useContext(asg_1.ResponsiveContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Divider, null),
        react_1.default.createElement(asg_1.Box, { "data-testid": "1", width: "100%", pad: {
                top: '24px',
                horizontal: responsiveSize === 'xs' ? 'medium' : 'large'
            } },
            react_1.default.createElement(asg_1.Box, { width: "100%", maxWidth: "704px !important", "data-testid": "2", margin: { horizontal: 'auto' } },
                react_1.default.createElement(asg_1.FlexGrid, { direction: "row-reverse", "data-testid": "3" },
                    rightButton && (react_1.default.createElement(Styles_1.StyledFlexGridItem, { sm: 6, height: "fit-content" },
                        react_1.default.createElement(asg_1.Button, tslib_1.__assign({ primary: true, width: "100%", margin: { bottom: '24px' } }, rightButton, { "data-testid": "rightButton" })))),
                    leftButton && (react_1.default.createElement(Styles_1.StyledFlexGridItem, { sm: 6, height: "fit-content" },
                        react_1.default.createElement(asg_1.Button, tslib_1.__assign({ secondary: true, width: "100%", margin: { bottom: '24px' } }, leftButton, { "data-testid": "leftButton" })))))))));
};
exports.default = ContentFooter;
//# sourceMappingURL=ContentFooter.js.map